/* eslint-disable no-console */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button } from 'antd';
import InputSelectField from '../form-helpers/InputSelectField';
import { FormInputArea } from '../form-helpers/FormField';
import LoadingSpinner from '../../common/LoadingSpinner';
import { errorNotification } from '../../../utils/notification-helpers';
import SharedWithList from './SharedWithList';

const data = [
  {label: 'Medication 1', value: 'Medication 1'},
  {label: 'Medication 2', value: 'Medication 2'},
  {label: 'Medication 3', value: 'Medication 3'},
  {label: 'Medication 4', value: 'Medication 4'},
]

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

function MedicationsForm({ onSubmitBtnText, onSubmitForm, dataMedicalHistory }) {
  const { t } = useTranslation(['common', 'medical-history']);

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        medications: Yup.string().required(t('form.error.required'))
      }),
    [t]
  );

  const initialValues = {
    medications: dataMedicalHistory && dataMedicalHistory.medications ? dataMedicalHistory.medications : '',
  };

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = dataMedicalHistory ?? {};
          dataForm.medications = values.medications
          console.log("dataForm", dataForm)
          onSubmitForm(dataForm)
        }}
      >
        {({ isSubmitting, isValid, setFieldValue }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <FormInputArea
                  name="medications"
                  style={{ width: '100%', padding: '3%' }}
                  formItemLayout={formItemLayout}
                  onChange={(e) => setFieldValue("medications", e.target.value)}
                  rows={6}
                />
                {/* <InputSelectField
                  name="enterMedicationName"
                  label={t('medical-history:medications.form.enterMedicationName.label')}
                  placeholder={t('medical-history:medications.form.enterMedicationName.placeholder')}
                  options={data}
                />
                <Box>
                  <SharedWithList
                    title={t('medical-history:medications.form.yourMedication.label')}
                    emptyTitle={t('medical-history:medications.form.yourMedication.noSelected')}
                    list={[]}
                    onRemove={onRemove} />
                </Box> */}
                <Box paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    {isSubmitting ? <LoadingSpinner position="full" transparent={false} /> : onSubmitBtnText}
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

MedicationsForm.defaultProps = {
  onSubmitBtnText: 'Save & Update',
};

const { string, func } = PropTypes;

MedicationsForm.propTypes = {
  onSubmitBtnText: string,
  onSubmitForm: func.isRequired,
  dataMedicalHistory: PropTypes.objectOf(PropTypes.any).isRequired
};

export default MedicationsForm;
